import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _extends from "@babel/runtime/helpers/extends";
// TODO: Update the code below and remove these disabling statements
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/role-supports-aria-props */
import React, { useState } from 'react';
import PropTypes from 'prop-types';

// import HeaderContext from '../HeaderContext';
import NavItem from './NavItem';
import SubNav from './SubNav';
import { navAccessibility } from '../scripts/accessibility';
var NAV_POSITION = 'side';
var handleKeyDown = function handleKeyDown(event) {
  return navAccessibility({
    event: event,
    navPosition: NAV_POSITION
  });
};
var closeSideNav = function closeSideNav() {
  var closeMenuButton = document.querySelector('.header__nav-top__button-menu--icon');
  closeMenuButton.click();
};
var renderNavItems = function renderNavItems(_ref) {
  var navItems = _ref.navItems,
    navSideOpen = _ref.navSideOpen,
    closeMenu = _ref.closeMenu,
    isClub = _ref.isClub,
    setSideSubnav = _ref.setSideSubnav,
    sideSubnav = _ref.sideSubnav,
    locale = _ref.locale;
  if (!navItems || !navItems.length) {
    return null;
  }
  var currentNavItemText = sideSubnav.parentNavItem && sideSubnav.parentNavItem.text;
  var subNavSequence = 0;

  /**
   * Reorder Nav Items
   * MLB - Move Team nav item to top
   * Club - Add 'isDefaultNav' prop to first item with a subnav (Don't move item)
   **/
  var reorderedNavItems = navItems.reduce(function (arr, item) {
    if (isClub && subNavSequence === 0 && item.subnav) {
      item.isDefaultNav = true;
      arr.push(item);
      subNavSequence++;
    } else if (!isClub && item.subnavModule === 'teammodule') {
      item.isDefaultNav = true;
      arr.unshift(item);
    } else {
      arr.push(item);
    }
    return arr;
  }, []);
  return reorderedNavItems.map(function (item, i) {
    var id = item.id,
      isDefaultNav = item.isDefaultNav,
      teamData = item.teamData,
      text = item.text;
    var props = {
      className: 'header__nav-side__nav-item',
      closeMenu: closeMenu,
      isClub: isClub,
      isDefaultNav: isDefaultNav,
      navItem: item,
      navPosition: NAV_POSITION,
      navSideOpen: navSideOpen,
      setSideSubnav: setSideSubnav,
      subNavIndicator: '>',
      teamData: teamData,
      collapseSubnav: true,
      locale: locale,
      key: id || "nav-side-".concat(i)
    };
    if (currentNavItemText === text) {
      props.collapseSubnav = false;
    }
    return /*#__PURE__*/React.createElement(NavItem, _extends({
      key: item.id
    }, props));
  });
};
var SideNav = function SideNav(_ref2) {
  var navSideOpen = _ref2.navSideOpen,
    closeMenu = _ref2.closeMenu,
    navSideItems = _ref2.navSideItems,
    locale = _ref2.locale,
    isClub = _ref2.isClub;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    sideSubnav = _useState2[0],
    setSideSubnav = _useState2[1];
  var hasSubnav = Boolean(sideSubnav.subNavData);
  var navItems = renderNavItems({
    navItems: navSideItems,
    navSideOpen: navSideOpen,
    closeMenu: closeMenu,
    isClub: isClub,
    setSideSubnav: setSideSubnav,
    sideSubnav: sideSubnav,
    locale: locale
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("nav", null, /*#__PURE__*/React.createElement("ul", {
    className: "header__nav-side",
    "aria-expanded": navSideOpen,
    "aria-haspopup": "true",
    id: "header__nav-side" // For button aria-controls
  }, /*#__PURE__*/React.createElement("li", {
    className: "header__nav-side__main-nav"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "header__nav-side__nav-items",
    "aria-label": "Side Main Navigation"
  }, navItems), /*#__PURE__*/React.createElement("div", {
    className: "scroll-buffer"
  })), /*#__PURE__*/React.createElement("li", {
    className: "header__nav-side__subnav".concat(!hasSubnav ? '--transparent' : ''),
    onKeyDown: handleKeyDown,
    onClick: function onClick() {
      return !hasSubnav ? closeSideNav() : null;
    }
  }, hasSubnav && /*#__PURE__*/React.createElement(SubNav, {
    subNavData: sideSubnav.subNavData,
    locale: sideSubnav.locale,
    parentNavItem: sideSubnav.parentNavItem,
    navPosition: NAV_POSITION
  }), /*#__PURE__*/React.createElement("div", {
    className: "scroll-buffer"
  })))));
};
export default SideNav;
SideNav.propTypes = {
  navSideItems: PropTypes.instanceOf(Array).isRequired,
  navSideOpen: PropTypes.bool,
  closeMenu: PropTypes.func,
  locale: PropTypes.string,
  isClub: PropTypes.bool
};